import MyTeam from './MyTeam';
export default MyTeam;
